import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from '../../../../../../index';
import FormsRow from '../../../../../FormsRow/FormsRow';
import FormInput from '../../../../../FormInput/FormInput';
import { Namespace } from '../../../../../../../../../translation/namespace';

import { FormSubmitButton } from '../../../../../FormSubmitButton/FormSubmitButton';
import { LinkchooserLinkType } from '../../../../../../../../../types/api/LinkchooserLinkType';
import { InputType } from '../../../../../../InputTypes';

export function LinkchooserExternalTemplate() {
  const { inputs, onChange, submitActionEnabled } = useFormContext();
  const { t } = useTranslation(Namespace.Linkchooser);

  const linkType = LinkchooserLinkType.External;

  return (
    <>
      <FormsRow>
        {inputs.q.type === InputType.TEXT && (
          <FormInput
            id={`${inputs.q.name}-input`}
            labelTitle={t(`${linkType}.q.label`)}
            labelHelpText={t('external.q.helpText')}
            name={inputs.q.name}
            value={inputs.q.value}
            required={inputs.q.required}
            maxLength={inputs.q.constraints?.maxLength}
            onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => onChange(inputs.q.name, value)}
            type="url"
          />
        )}
      </FormsRow>
      <FormsRow>
        <FormInput
          id="linkchooser-text-input"
          labelTitle={t(`${linkType}.text.label`)}
          name={inputs.text.name}
          value={inputs.text.value}
          required
          maxLength={inputs.text.constraints?.maxLength}
          onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => onChange(inputs.text.name, target.value)}
        />
      </FormsRow>
      <FormSubmitButton
        buttonLabel={t(`${linkType}.submitFormButtonLabel`)}
        enabled={submitActionEnabled() && ((inputs.q.value && inputs.q.value !== '') || inputs.text.valueChanged())}
      />
    </>
  );
}
